module.exports = __webpack_public_path__ + "img/share.bc45e9b1.svg";